import EditViewToggleButton from 'Components/Generic/Buttons/EditViewToggleButton';
import DetailPanel from 'Components/Generic/DetailPanel/index';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import styles from './DetailTable.module.css';

const EditableDetailPanel = ({
  children,
  renderChild,
  renderFooter,
  editable,
  parentEditState,
  hideToggle = false,
  disabled = false,
  ...props
}) => {
  const [inEditState, setInEditState] = useState(false);

  useEffect(() => {
    parentEditState !== undefined && setInEditState(parentEditState);
  }, [parentEditState]);

  const handleDoubleClick = (event) => {
    event.preventDefault();
    if (!editable || inEditState) return;
    setInEditState(!inEditState);
  };

  let shouldShowEditButton = editable && !hideToggle && !disabled;

  return (
    <DetailPanel
      {...props}
      editable={editable}
      disabled={disabled}
      onDoubleClick={shouldShowEditButton ? handleDoubleClick : undefined}
      titleButton={
        shouldShowEditButton && (
          <EditViewToggleButton
            className={styles.edit_view_button}
            miniVersion
            toggleHandler={() => setInEditState(!inEditState)}
            editState={inEditState}
          />
        )
      }
      footer={
        (renderFooter && renderFooter(inEditState)) ||
        (inEditState && props.footer)
      }>
      {renderChild ? renderChild(inEditState) : children}
    </DetailPanel>
  );
};

EditableDetailPanel.propTypes = {
  children: PropTypes.node,
  renderChild: PropTypes.func,
  renderFooter: PropTypes.func,
  editable: PropTypes.bool,
  parentEditState: PropTypes.bool,
  hideToggle: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default EditableDetailPanel;
